import { Resources } from 'constants/resources';

import { ResourceProps } from 'react-admin';

import { CumulativeReportList } from './CumulativeReportList';

export const cumulativeReportResource: ResourceProps = {
  name: Resources.CumulativeReport,
  create: <></>,
  edit: <></>,
  show: <></>,
  list: CumulativeReportList,
};
